"use strict";

Shopify.theme.jsProductShowcase = {
    init: function init($section) {
        // Add settings from schema to current object
        Shopify.theme.jsProductShowcase = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
        let $nav_outer = $section.find('[data-nav-outer] > div')
        let $slideshow_outer = $section.find('[data-slideshow-outer]').removeClass('is-hidden');
        let $nav_inner = $section.find('[data-nav-inner] > div')
        let $slideshow_inner = $section.find('[data-slideshow-inner]').removeClass('is-hidden');
		let $mobileframe = $('.product_showcase--frame.mobile-frame')
        let $mobileSlider = $mobileframe.siblings('.product_showcase--slider-inner')

        var $slider_outer = $slideshow_outer.flickity({
            wrapAround: false,
            draggable: false,
            imagesLoaded: true,
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false,
            watchCSS: true
        });
        $mobileSlider.css('max-width',$mobileframe.width())
        setTimeout(function() {
            $mobileSlider.css('max-width',$mobileframe.width())
            $slider_outer.flickity('resize');
        }, 500);
      
        $slideshow_inner.on('dragMove.flickity', function( event, pointer ) {
          let $cursor = $('.cursor');
          if(!$cursor.length){
            $slideshow_inner.off('dragMove.flickity')
            return
          }
          $cursor.css({
              top: event.clientY - $cursor.height() / 2,
              left: event.clientX - $cursor.width() / 2
          });
        });
      
        $nav_outer.on('click', function() {
            $nav_outer.removeClass('is-active')
            $(this).addClass('is-active')
            let index = $(this).data('index')
            $slider_outer.flickity('select', index, false, false)
        })
        $slider_outer.on('change.flickity', function(event, index) {
            $nav_outer.removeClass('is-active')
            $nav_outer.eq(index).addClass('is-active')
        });

        $nav_inner.on('click', function() {
            let item = $(this).data('item')
            $nav_inner.removeClass('is-active')
            $(this).addClass('is-active')

            $slideshow_inner.find(`[data-item]`).addClass('is-hidden')
            $slideshow_inner.find(`[data-item="${item}"]`).removeClass('is-hidden')
            $slider_outer.flickity('resize');
            setTimeout(function() {
                $slider_outer.flickity('resize');
            }, 500);
        })
    },
    blockSelect: function blockSelect($section, blockId) {
        var $slider = $section.find('[data-image-experts]');
        var $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
        $slider.flickity('select', $sliderIndex, true, true);
    },
    unload: function unload($section) {}
};